var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error",class:{ inline: _vm.inline }},[(_vm.show)?_c('span',[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }